import { useTranslation } from "react-i18next";
import { Text } from "~/components/text";
import type { GenerationEvent } from "~/pages/product-details/tabs/sales-data-tab/hooks/use-metadata-events";
import { kindLabel } from "./kind-label";

export const GenerationTooltipContent = ({
  event,
}: {
  event: GenerationEvent;
}) => {
  const { t } = useTranslation(["productDetails"]);
  const { generation } = event;

  return (
    <div className="min-w-48">
      <Text as="p" variant="body">
        <Text as="span" variant="muted">
          {t("productDetails:salesData.events.generation.generated")}:
        </Text>{" "}
        {kindLabel(t, generation.kind)}
      </Text>

      {generation.count != null && (
        <Text as="p" variant="muted" className="mt-0.5">
          {t("productDetails:salesData.events.generation.count", {
            count: generation.count,
          })}
        </Text>
      )}
    </div>
  );
};
